import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <h5>
        Find the source code on{" "}
        <a href="https://github.com/zilkupcin/pickyflyer" target="_blank">
          GitHub
        </a>
      </h5>
    </footer>
  );
};

export default Footer;
